<div class="wrap">
  <mat-dialog-content>
    <form [formGroup]="addLicenseForm" #addLicense (ngSubmit)="onSubmit()">
      <h2>Add a license</h2>
      <mat-form-field appearance="outline">
        <mat-label>Customer</mat-label>
        <mat-select appearance="outline" formControlName="client">
          <ng-container *ngFor="let c of possibleClients">
            <mat-option [value]="c">{{ c.name }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select appearance="outline" formControlName="type">
          <ng-container *ngFor="let t of types">
            <mat-option [value]="t">{{ t.name }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-slide-toggle
        [checked]="true"
        class="checkbox"
        [color]="color"
        formControlName="hasExpiryDate"
        >Has expiry date</mat-slide-toggle
      >

      <mat-form-field
        appearance="outline"
        *ngIf="addLicenseForm.value.hasExpiryDate"
      >
        <mat-label>Expiry date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [placeholder]="test"
          [disabled]="!addLicenseForm.value.hasExpiryDate"
          formControlName="expiryDate"
        />
        <!-- [min]="minDate" -->
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>Please enter a date like DD/MM/YYYY</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Number of uses</mat-label>
        <input matInput formControlName="uses" type="number" />
        <mat-error>Must be a positive number</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Comment</mat-label>
        <textarea
          matInput
          placeholder="Leave a comment about this license..."
          formControlName="comment"
          maxlength="200"
        ></textarea>
      </mat-form-field>

      <div class="btn_action">
        <button class="canceled" type="button" (click)="dialog.closeAll()">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="addLicenseForm.invalid"
          [ngClass]="{
            isInactive: addLicenseForm.invalid,
            isActive: addLicenseForm.valid
          }"
        >
          Add
        </button>
      </div>
    </form>
  </mat-dialog-content>
</div>
